module.exports = __webpack_public_path__ + "static/media/United-States.7fc1418a.png";